import JSBI from 'jsbi'

export const INIT_CODE_HASH = '0x3288bb36e56843ec3f12b7bd92a03abc2013886e116207e89d2d6963533b60c6'

export const MINIMUM_LIQUIDITY = JSBI.BigInt(1000)

// exports for internal consumption
export const ZERO = JSBI.BigInt(0)
export const ONE = JSBI.BigInt(1)
export const FIVE = JSBI.BigInt(5)
export const _997 = JSBI.BigInt(997)
export const _1000 = JSBI.BigInt(1000)
